import React, { Component, Fragment } from "react";
import { Table } from "antd";
import ChangePath from "../../../services/ServiceApi";

const columns = [
  {
    title: "Material No.",
    dataIndex: "number",
    key: "number",
    sorter: (a, b) => a.number.length - b.number.length,
  },
  {
    title: "Model name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    sorter: (a, b) => a.description.length - b.description.length,
  },
  {
    title: "Stock On Hand",
    dataIndex: "stock",
    key: "stock",
    sorter: (a, b) => a.stock - b.stock,
  },
  {
    title: "Min",
    dataIndex: "min",
    key: "min",
    sorter: (a, b) => a.min - b.min,
  },
  {
    title: "Max",
    dataIndex: "max",
    key: "max",
    sorter: (a, b) => a.max - b.max,
  },
  {
    title: "Unit price",
    dataIndex: "price",
    key: "price",
    sorter: (a, b) => a.price - b.price,
  },
];

class MaterialList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [
        {
          key: "1",
          number: "BACC010001",
          name: "TOA Rust-Pro Protective oil",
          description: "Adapter Router",
          stock: 31,
          min: 5,
          max: 10,
          price: 2000,
        },
        {
          key: "1",
          number: "BACC010002",
          name: "TOA Rust-Pro Protective oil",
          description: "Adapter กล่อง Digital",
          stock: 0,
          min: 5,
          max: 10,
          price: 2500,
        },
        {
          key: "1",
          number: "BACC010003",
          name: "TOA Rust-Pro Protective oil",
          description: "แปรงล้าง (HA200)",
          stock: 20,
          min: 5,
          max: 10,
          price: 1000,
        },
        {
          key: "1",
          number: "BACC010004",
          name: "TOA Rust-Pro Protective oil",
          description: "ฐานรองกระป๋องแปรงล้าง 2ชิ้น (TM300)",
          stock: 51,
          min: 5,
          max: 10,
          price: 3000,
        },
      ],
      visible: false,
      title: "Material",
    };
  }
  render() {
    const { title, data } = this.state;
    return (
      <Fragment>
        <div className="row">
          <div className="col-6">
            <input type="text" placeholder="Search" className="inputsearch" />
            <img
              src={ChangePath.absoluteUrl("/icon/scarch.svg")}
              className="mr-3 searchicon"
              alt="searchicon"
            />
          </div>
          <div className="col-6" style={{ textAlign: "right" }}>
            <button
              style={{ height: "36px" }}
              className="btn btn-warning"
              onClick={() => this.onModal("team", true)}
            >
              <img
                src={ChangePath.absoluteUrl("/img/modal_approve.svg")}
                className="mr-2"
                alt="m-approve"
              />
              Add {title}
            </button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="card-table-ma">
            <div
              className="row"
              style={{
                background: "#F8FAFB",
                marginLeft: "0px",
                marginRight: "0px",
              }}
            >
              <div
                className="col-2"
                style={{
                  background: "#000F9F",
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                <div style={{ height: "36px", marginTop: "10px" }}>
                  <span>ALL MATERIAL (1,000)</span>
                </div>
              </div>
              <div className="col-8"></div>
              <div
                className="col-2"
                style={{ textAlign: "right", marginTop: "10px" }}
              >
                <span>Show</span>
                <select style={{ marginLeft: "10px", color: "#000F9F" }}>
                  <option value="A">10</option>
                  <option value="B">20</option>
                  <option value="C">50</option>
                </select>
                <span style={{ marginLeft: "10px" }}>Entries</span>
              </div>
            </div>
            <div className="body mt-3">
              <div style={{ marginLeft: "15px", marginRight: "15px" }}>
                <Table
                  columns={columns}
                  dataSource={data}
                  onChange={this.handleChange}
                />

                <div
                  style={{
                    height: "36px",
                    marginTop: "10px",
                    top: "573px",
                    position: "absolute",
                    color: "#6F6F6F",
                  }}
                >
                  <span>Showing</span>
                  <span style={{ marginLeft: "5px" }}>1</span>
                  <span style={{ marginLeft: "5px" }}>To</span>
                  <span style={{ marginLeft: "5px" }}>10</span>
                  <span style={{ marginLeft: "5px" }}>Of</span>
                  <span style={{ marginLeft: "5px" }}>1,000</span>
                  <span style={{ marginLeft: "5px" }}>Entries</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MaterialList;
